<div class="atlas-dialog-container">
  <atlas-dialog-header
    headerText="Prompt Arguments"
    i18n-headerText="@@promptArgumentsHeaderText"
  ></atlas-dialog-header>

  <mat-dialog-content class="mat-dialog-content">
    <div class="form-controls-padding header-padding">
      <ai-prompt-arguments-form
        [promptArguments]="data.arguments"
        #argumentsForm
      >
      </ai-prompt-arguments-form>
    </div>
  </mat-dialog-content>

  <atlas-dialog-footer>
    <div class="buttons-container">
      <atlas-dialog-cancel-button></atlas-dialog-cancel-button>
      <atlas-dialog-affirmative-close-button
        label="Accept"
        i18n-label="@@acceptButtonLabel"
        (clicked)="onConfirmButtonClicked(argumentsForm)"
        [disabled]="argumentsForm.invalidForm()"
      ></atlas-dialog-affirmative-close-button>
    </div>
  </atlas-dialog-footer>
</div>
